// src/pages/RegisterPage.tsx
import React from 'react';
import '../Styles/RegisterPage.css';

const RegisterPage: React.FC = () => {
  return (
    <div className="register-container">
      <div className="register-card">
        <h1>Anonymous Registration</h1>
        <p>Quickly register without creating a full account to access basic features and provide feedback.</p>
        
        <form className="register-form">
          <div className="form-group">
            <label>Email Address</label>
            <input 
              type="email" 
              placeholder="you:email@example.com" 
            />
          </div>
          
          <div className="form-group">
            <label>Affiliation / Organization</label>
            <input 
              type="text" 
              placeholder="e.g., University Hospital, Research Institute" 
            />
          </div>
          
          <div className="form-group">
            <label>Country of Residence</label>
            <select>
              <option>United States</option>
              {/* Other countries would be added */}
            </select>
          </div>
          
          <div className="form-group">
            <label>Primary Qualification</label>
            <select>
              <option>Medical Doctor (MD)</option>
              <option>Registered Nurse (RW)</option>
              <option>Radiologist</option>
              <option>Medical Technician</option>
              <option>Student</option>
              <option>Other Healthcare Professional</option>
            </select>
          </div>
          
          <div className="form-group">
            <label>Current Role (Optional)</label>
            <input 
              type="text" 
              placeholder="e.g., Junior Researcher, Imaging Specialist" 
            />
          </div>
          
          <button type="submit" className="submit-btn">Register Anonymously</button>
        </form>
        
        <div className="login-link">
          Already have an account? <a href="#">Log in here</a>.
        </div>
        
        <div className="made-with">
          Made with <span>Visily</span>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;